import { useEffect } from 'react';
import bgimage from '../images/intro/bgimage.png';

/**
 * Component to preload LCP image
 * Adds preload link to head for the hero slider background image
 * Optimized to run only once and prevent duplicate preload links
 */
const LCPPreload = () => {
  useEffect(() => {
    // Check if preload link already exists
    const existingLink = document.querySelector('link[rel="preload"][as="image"][data-lcp="true"]');
    
    if (!existingLink && bgimage) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = bgimage;
      link.setAttribute('fetchpriority', 'high');
      link.setAttribute('data-lcp', 'true');
      // Insert early in head for faster discovery
      const firstChild = document.head.firstChild;
      if (firstChild) {
        document.head.insertBefore(link, firstChild);
      } else {
        document.head.appendChild(link);
      }
    }
  }, []);

  return null;
};

export default LCPPreload;


